/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { LegalEntitiesApiConfig } from '../api-config';

import { LegalEntitiesApi } from '../models';

@Injectable()
export class LegalEntitiesReservationsApiClient extends BaseApiClient<LegalEntitiesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.legalEntitiesApiConfig);
  }

  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<LegalEntitiesApi.ReservationDto>>>;
  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<LegalEntitiesApi.ReservationDto>>>;
  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<LegalEntitiesApi.ReservationDto>>>;
  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<LegalEntitiesApi.ReservationDto>>>;
  legalEntitiesReservationsControllerGetReservations(
    params: { xSgUser?: string; lenderId: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['lenderId', params.lenderId]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<LegalEntitiesApi.ReservationDto>>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.lenderId))}/reservations`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.ReservationDto>;
  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.ReservationDto>;
  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerCreateReservation(
    params: { body: LegalEntitiesApi.CreateReservationRequest; xSgUser?: string; lenderId: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['lenderId', params.lenderId]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<LegalEntitiesApi.ReservationDto>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.lenderId))}/reservations`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.ReservationDto>;
  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.ReservationDto>;
  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.ReservationDto>>;
  legalEntitiesReservationsControllerLiftReservation(
    params: {
      body?: LegalEntitiesApi.LiftReservationRequest;
      xSgUser?: string;
      lenderId: string;
      reservationId: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['lenderId', params.lenderId], ['reservationId', params.reservationId]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.delete<LegalEntitiesApi.ReservationDto>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.lenderId))}/reservations/${this.encodeURI(String(params.reservationId))}`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
